<form #form="ngForm" (ngSubmit)="onSave(form)">
	<div class="flex gap-x-4 justify-between">
		<div class="w-2/4 flex flex-col gap-y-6">
			<h3>{{ vtbMortgageAdjustment.title }}</h3>
			<app-input
				name="title"
				[(ngModel)]="vtbMortgageAdjustment.title"
			></app-input>
			<p>
				Principal amount of VTB:
				<span class="font-bold">{{ vtbMortgage.amount | centsToDollars }}</span>
			</p>
			<app-mortgage-net-amount
				class="mt-2"
				[editable]="true"
				[showPrincipalAmount]="false"
				[showFinalCredit]="false"
				[mortgage]="vtbMortgage"
			></app-mortgage-net-amount>
			<app-checkbox
				name="details"
				type="clear"
				[(ngModel)]="vtbMortgageAdjustment.details"
			>
				Include all details in document</app-checkbox
			>
			<div class="flex justify-between">
				<app-button btn="clear" size="small" mat-dialog-close
					>Cancel</app-button
				>
				<app-button size="small" type="submit">Save</app-button>
			</div>
		</div>

		<div class="w-2/4">
			<app-container type="dark" title="Details">
				<div class="flex flex-col gap-y-3">
					<div
						class="flex justify-between"
						*ngFor="let deduction of vtbMortgage?.netAdvancedAmounts"
					>
						<p>{{ deduction.description }}</p>
						<p>{{ deduction.amount | centsToDollars }}</p>
					</div>

					<div class="flex justify-end">
						<p class="font-bold">
							Credit purchaser = {{ totalAmount | centsToDollars }}
						</p>
					</div>
				</div>
			</app-container>
		</div>
	</div>
</form>
